import { CommonModule } from "@angular/common";
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

type AvatarShape = "circle" | "square" | "rounded";
type AvatarSize = "xl" | "lg" | "md" | "sm" | "xs";
type AvatarStatus = "online" | "offline";

@Component({
    selector: "avatar",
    templateUrl: "avatar.component.html",
    standalone: true,
    imports: [CommonModule, MatIconModule],
    styleUrls: ["./avatar.component.scss"],
})
export class AvatarComponent implements OnChanges {
    @Input() shape: AvatarShape;
    @Input() size: AvatarSize;
    @Input() status: AvatarStatus;
    @Input() imageUrl: string;
    @Input() userName: string;
    classes: string[] = [];

    ngOnChanges(changes: SimpleChanges) {
        this.classes = [];

        if (changes.shape?.currentValue) {
            this.classes.push(changes.shape.currentValue);
        }

        if (changes.size?.currentValue) {
            this.classes.push(changes.size.currentValue);
        }

        if (changes.status?.currentValue) {
            this.classes.push(changes.status.currentValue);
        }
    }
}
